import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import AmostrasPlacasIndexProducao from '@/pages/amostras-placas/AmostrasPlacasIndexProducao.vue';

const routes: RouteConfig[] = [
  {
    path: '/placas/producao',
    name: 'AmostrasPlacasIndexProducao',
    component: AmostrasPlacasIndexProducao,
    meta: {
      icon: 'mdi-chip',
      rules: [CaslRules.AmostraPlaca.listarProducao],
    },
  },
];

export default routes;
